"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenStatsRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Config_1 = require("../../Config");
const SubCrudRepository_1 = require("../SubCrudRepository");
class TokenStatsRepository extends SubCrudRepository_1.SubCrudRepository {
    constructor(env) {
        super(env || Config_1.Build5Env.PROD, interfaces_1.PublicCollections.TOKEN, interfaces_1.PublicSubCollections.STATS);
    }
}
exports.TokenStatsRepository = TokenStatsRepository;
